export default class PaymentController {
  _data = {
    document_id: null,
    payment_date: null,
    payment_discount_type: null,
    payment_discount_amount: null,
    payment_interest_type: null,
    payment_interest_amount: null,
    payment_fine_type: null,
    payment_fine_amount: null,
    rate_amount: null,
    rate_historic_id: null,
    rate_currency_id: null,
    payment_comment: null,
    unblock_customer: true,
    payment_type: null,
    document_number: null
  }

  constructor(input) {
    this._data.payment_type = "debit_card_machine"
    this.setData(input, this._data)
  }

  setData(input, data) {
    if (!input) return null
    /**
     * For all attributes defined in _data,
     * look up for a match in data function's param
     */
    for (const key in input) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        data[key] = input[key]
      }
    }
  }

  getData() {
    return this._data
  }
}